import type { HTMLAttributes } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './text.module.scss';

const styles = pickCss(css, css.root);

type TextElement = 'p' | 'span' | 'label';
type TextVariant = 'body' | 'muted' | 'caption' | 'error';
type TextSize = 'lg' | 'base' | 'sm' | 'xs';
type TextWeight = 'normal' | 'medium' | 'semibold';

type TextProps = HTMLAttributes<HTMLElement> & {
  as?: TextElement;
  variant?: TextVariant;
  size?: TextSize;
  weight?: TextWeight;
};

export const Text = ({
  as: Tag = 'span',
  variant = 'body',
  size = 'base',
  weight = 'normal',
  className,
  children,
  ...restProps
}: TextProps) => (
  <Tag className={styles({ variant, size, weight }, className)} {...restProps}>
    {children}
  </Tag>
);
